import FacilitatorJamSettings from '@/src/components/game/FacilitatorJamSettings/FacilitatorJamSettings';
import React from 'react';

export const JamEventSettingsPage: React.FC = () => {
  return <FacilitatorJamSettings />;
};
